import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  API,
  GlobalActions,
  LoadingContent,
} from 'vibeguide';
import LocationDetails from './LocationDetails';

class LocationSidebar extends PureComponent {
  constructor(props) {
    super(props);

    // fetch company to see if the ad program toggle should be enabled
    this.company = {};

    this.state = {
      location: {
        displaySettings: {
          resolution: { name: '', size: [0, 0] },
          screenDimensions: [0, 0],
          screenDiagonal: 0,
          screenRotation: 0,
          contentRotation: 0,
          advancedEnabled: false,
          displayAreaDimensions: [0, 0],
          displayAreaPosition: [0, 0],
        },
      },
    };
  }

  componentDidMount() {
    const {
      locationId,
    } = this.props;

    if (locationId && locationId !== 'new') {
      this.getLocation();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      locationId,
      isNew,
    } = this.props;

    const {
      locationId: prevLocationId,
    } = prevProps;

    if (locationId && !isNew && locationId !== prevLocationId) {
      this.getLocation();
    }
  }

  /**
   * Update the location
   */
  onUpdate = async (data) => {
    if (data.companyId === '') {
      // removing the selected company, reset the saved company details
      this.company = {};
      // reset the ad program enabled toggle when the company is cleared
      data.adProgramEnabled = false;
      data.adNetworkEnabled = false;
    }

    // get company if set to enable/disable the ad program toggle
    this.company = data.companyId
      ? await API.Company.getById(data.companyId)
      : this.company;

    this.setState((state) => {
      return {
        location: {
          ...state.location,
          ...data,
          // allow enabling ad program only if the company has it enabled
          companyAdProgramEnabled: this.company.adProgramEnabled || false,
          companyAdNetworkEnabled: this.company.adNetworkEnabled || false,
        },
      };
    });
  };

  /**
   * Close the sidebar
   */
  onClose = () => {
    const {
      setPanel,
    } = this.props;

    setPanel({
      show: false,
    });
  };

  getLocation = async () => {
    const {
      locationId,
    } = this.props;

    const location = await API.Location.getById(locationId);
    const company = await API.Company.getById(location.companyId);

    // save the company ad program status
    location.companyAdProgramEnabled = company.adProgramEnabled;
    location.companyAdNetworkEnabled = company.adNetworkEnabled;

    // save the company
    this.company = company;

    // Hoist a legacy top-level `resolution`/`resolutionSize` into the new
    // canonical `displaySettings.resolution` shape so the form always works
    // off the nested object.
    const rawDisplaySettings = location.displaySettings || {};
    let nestedResolution = rawDisplaySettings.resolution;

    if (!nestedResolution && location.resolution) {
      if (typeof location.resolution === 'object') {
        nestedResolution = {
          _id: location.resolution._id,
          name: location.resolution.name || '',
          size: location.resolution.size || location.resolutionSize || [0, 0],
          custom: Boolean(location.resolution.custom),
        };
      } else {
        nestedResolution = {
          name: location.resolution,
          size: location.resolutionSize || [0, 0],
          custom: typeof location.resolution === 'string'
            && location.resolution.toLowerCase().startsWith('custom'),
        };
      }
    }

    delete location.resolution;
    delete location.resolutionSize;

    location.displaySettings = {
      resolution: { name: '', size: [0, 0] },
      screenDimensions: [0, 0],
      screenDiagonal: 0,
      screenRotation: 0,
      contentRotation: 0,
      advancedEnabled: false,
      displayAreaDimensions: [0, 0],
      displayAreaPosition: [0, 0],
      ...rawDisplaySettings,
      ...(nestedResolution ? { resolution: nestedResolution } : {}),
    };

    this.setState({
      location,
    });
  };

  render() {
    const {
      locationId,
      isNew,
    } = this.props;

    const {
      location,
    } = this.state;

    return (
      <div
        className="LocationSidebar"
        style={{
          height: '100%',
        }}
      >
        <LocationDetails
          locationData={location}
          isNew={isNew}
          onClose={this.onClose}
          onUpdate={this.onUpdate}
        />

        {locationId && !location._id && (
          <LoadingContent />
        )}
      </div>
    );
  }
}

LocationSidebar.propTypes = {
  locationId: PropTypes.string,
  /** New Location */
  isNew: PropTypes.bool,
};

LocationSidebar.defaultProps = {
  locationId: null,
  isNew: false,
};

const mapDispatchToProps = {
  setPanel: GlobalActions.setPanel,
};

export default connect(null, mapDispatchToProps)(LocationSidebar);
